import api from "./core";

const basePath = "api/core/Menus";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(filter) {
    return api.post(`${basePath}`, filter);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  },
  moveMenuItem(data) {
    return api.post(`${basePath}/MoveMenuItem`, data);
  },
  moveMenu(data) {
    return api.post(`${basePath}/MoveMenu`, data);
  }
};
